import { Button, Box, Dialog, DialogContent, DialogTitle, Typography, Checkbox, FormControlLabel } from '@mui/material';

import useDeleteApplication from './useDeleteApplication';

const DeleteApplication = ({ appInfo, appInstId, handleClose, handleDelete, ...props }) => {
    const {
        //States
        isDoingAjax,
        confirmation,

        //Styles
        blueTextSx,
        boldTextSx,
        instructionTextSx,
        deleteButtonSx,

        //Handlers
        handleCheckbox,
        reset,
        deleteApp,
    } = useDeleteApplication();

    const _handleClose = () => {
        reset();
        handleClose();
    };

    const _handleDelete = () => {
        deleteApp(appInstId, handleDelete);
    };

    return (
        <Dialog {...props}>
            <DialogTitle>Delete application</DialogTitle>
            <DialogContent>
                <Box>
                    <Typography>Please confirm that you wish to delete the below application. This action cannot be undone.</Typography>

                    <Box
                        id="instructions"
                        sx={instructionTextSx}
                    >
                        {Object.entries(appInfo)
                            .map(([key, value]) => {
                                return (
                                    <Box sx={boldTextSx}>
                                        {key}:{' '}
                                        <Box
                                            component="span"
                                            sx={blueTextSx}
                                        >
                                            {value || 'N/A'}
                                        </Box>
                                    </Box>
                                );
                            })
                            .reduce((acc, x) => (acc === null ? [x] : [acc, ' / ', x]), null)}
                    </Box>

                    <FormControlLabel
                        label="Yes, I wish to delete this application."
                        control={
                            <Checkbox
                                checked={confirmation}
                                onChange={(event) => handleCheckbox(event?.target?.checked)}
                            />
                        }
                    />
                </Box>

                <Box>
                    <Button
                        onClick={_handleClose}
                        disabled={isDoingAjax}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={_handleDelete}
                        id="delete-button"
                        variant="contained"
                        sx={deleteButtonSx}
                        disabled={!confirmation || isDoingAjax}
                    >
                        Delete application
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteApplication;
